import React, { useRef, useCallback, MouseEvent, useState, useEffect }  from 'react';
// import SB3Downloader from '../../containers/sb3-downloader.jsx';
import fileIcon from './file-icon.svg';
import fileIconSelected from './file-icon-selected.svg';
import './menu-bar.css';
import { useProjectActions } from "../project/project-hooks";
// import FileInputButton from "../common/FileInputButton";
import OpenButton from "../project/OpenButton"
import { useIntl } from "react-intl";
import { setProjectTitle, setMataProjectId, setWriteState, setProjectTitleold } from '../store/project-state'
import { useSelector, useDispatch } from 'react-redux'
// import { InMemoryFSStorage } from "../fs/storage";
import SaveWorkModal from './saveWorkModal/index'
import {toast} from 'react-hot-toast';
import { RootState } from '../store/modalStore'
import { setLoadingModal, setLoginModal } from '../store/modals'
import uploadBlob from '../lib/upload-blob';
import {message} from 'antd';


const WrapFileMenuItem = ({
  fileMenuOpen,
  canRemix,
  isRtl,
  canSave,
  canCreateCopy,
  onClickFile,
  onRequestCloseFile,
  onClickSave,
  onClickSaveAsCopy,
  handleClickNew,
  handleClickRemix,
  fs
}) => {
  let timer = null
  const intl = useIntl();
  const fileRef = useRef(null);
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const handleClickSaveAsCopy = () => {
    // Implement your logic here
  };
  // 我的作品内容是否保存
  const [saveWorkModal, setSaveWorkModal] = useState<boolean>(false);
  const [saveWorkState, setSaveWorkState] = useState<string>('py');
  const handleClickSave = () => {
    // Implement your logic here
  };

  const saveToComputer = (downloadProjectCallback) => () => {
    // Implement your logic here
  };
  // 是否有更新工作区内容
  const writeState = useSelector((state: RootState) => state.projectStore.writeState)

  // 新建指令块程序
  const handleOpenAiProject = () => {
    setSaveWorkState('')
    if (writeState) {
      setSaveWorkModal(true)
    } else {
      window.location.href = window.location.origin
    }
  }
  // 新建之后名称替换
  const actions = useProjectActions();
  const dispatch = useDispatch()

  const handleOpenNewWorks = () => {
    if (writeState) {
      setSaveWorkModal(true)
    } else {
      setSaveWorkState('py')
      actions.createFile(callBack => {
        if (callBack) {
          localStorage.setItem('projectTitle', callBack)
          location.reload()
          localStorage.removeItem('projectId')
          dispatch(setProjectTitle(callBack))
          dispatch(setProjectTitleold(callBack))
          dispatch(setMataProjectId(''))
        }
      })
    }

  }

  // 鼠标移入移除
  const [works, setWorks] = useState<boolean>(false);
  // 鼠标移动展示语言下拉框
  const handleMouseEnter = (event: MouseEvent) => {
      clearTimeout(timer);
      setWorks(true);
  }
  const handleMouseLeaveOuter = (event: MouseEvent) => {
      timer = setTimeout(() => {
          setWorks(false)
      }, 200);
  }
  // 鼠标移除事件
  const handleMouseLeave = (event: MouseEvent) => {
      setWorks(false);
  }
  // 关闭弹框x
  const handleCloseModal = () => {
      setSaveWorkModal(false)
  }
  // 放弃弹框
  const handleCancelModal = () => {
    setSaveWorkModal(false)
    dispatch(setWriteState(false))
    localStorage.removeItem('projectTitle')
    if (saveWorkState !== 'py') {
      window.location.href = window.location.origin
    } else {
      actions.createFile(callBack => {
        if (callBack) {
          localStorage.setItem('projectTitle', callBack)
          location.reload()
          localStorage.removeItem('projectId')
          dispatch(setProjectTitle(callBack))
          dispatch(setProjectTitleold(callBack))
          dispatch(setMataProjectId(''))
        }
      })
    }
}

  const titleNew = useSelector((state: RootState) => state.projectStore.title)
  const titleOld = useSelector((state: RootState) => state.projectStore.titleOld)
  const mataProjectId = useSelector((state: RootState) => state.projectStore.mataProjectId)
  let title = titleOld ? titleOld : titleNew

  const checkProjectName = () => {
    const value = titleNew && titleNew.trim();
    let countLimitCondition = null
    let specialCharacterCondition = null
    if (value) {
        var name = value.replace(/\.py$/, "");
        // 字符数字限制
        countLimitCondition = value.length > 30 || value.length < 1;
        // 限制特殊字符
        specialCharacterCondition = /[`~!@#$%^&*\-+=<>?:"{}|.,\/;'\\[\]·~！@#￥%……&*——\-+={}|《》？：“”【】、；‘’，。、]/.test(name);
    }

    if (!value || countLimitCondition || specialCharacterCondition){
        message.error(intl.formatMessage({
          id: "gui.mywork.projectNameRules",
          defaultMessage: "Project Name contain 1 to 30 characters"
        }))
        // toast.error('请勿输入特殊字符，并确保长度在1到30个字符之间')
        return false;
    }
    return true;
  }
  const loginState = useSelector((state: RootState) => state.userStore.loginState);
  const handleOpenLink = async () => {
    if (!checkProjectName()) return;
        if (loginState) {
            dispatch(setLoadingModal(true))
            let data = null

            data = new Uint8Array(fs['fs']['fs']['fs']['_files'][title]['_dataBytes']);
            const blob = new Blob([data], {
                type: "application/octet-stream",
            });
            const rsp = await new Promise((resolve, reject) => {
                uploadBlob(
                  titleNew,
                    // cover,
                    'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9InJlcGVhdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNDRjhCMTc7fQoJLnN0MXtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8dGl0bGU+cmVwZWF0PC90aXRsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTIzLjMsMTFjLTAuMywwLjYtMC45LDEtMS41LDFoLTEuNmMtMC4xLDEuMy0wLjUsMi41LTEuMSwzLjZjLTAuOSwxLjctMi4zLDMuMi00LjEsNC4xCgljLTEuNywwLjktMy42LDEuMi01LjUsMC45Yy0xLjgtMC4zLTMuNS0xLjEtNC45LTIuM2MtMC43LTAuNy0wLjctMS45LDAtMi42YzAuNi0wLjYsMS42LTAuNywyLjMtMC4ySDdjMC45LDAuNiwxLjksMC45LDIuOSwwLjkKCXMxLjktMC4zLDIuNy0wLjljMS4xLTAuOCwxLjgtMi4xLDEuOC0zLjVoLTEuNWMtMC45LDAtMS43LTAuNy0xLjctMS43YzAtMC40LDAuMi0wLjksMC41LTEuMmw0LjQtNC40YzAuNy0wLjYsMS43LTAuNiwyLjQsMEwyMyw5LjIKCUMyMy41LDkuNywyMy42LDEwLjQsMjMuMywxMXoiLz4KPHBhdGggY2xhc3M9InN0MSIgZD0iTTIxLjgsMTFoLTIuNmMwLDEuNS0wLjMsMi45LTEsNC4yYy0wLjgsMS42LTIuMSwyLjgtMy43LDMuNmMtMS41LDAuOC0zLjMsMS4xLTQuOSwwLjhjLTEuNi0wLjItMy4yLTEtNC40LTIuMQoJYy0wLjQtMC4zLTAuNC0wLjktMC4xLTEuMmMwLjMtMC40LDAuOS0wLjQsMS4yLTAuMWwwLDBjMSwwLjcsMi4yLDEuMSwzLjQsMS4xczIuMy0wLjMsMy4zLTFjMC45LTAuNiwxLjYtMS41LDItMi42CgljMC4zLTAuOSwwLjQtMS44LDAuMi0yLjhoLTIuNGMtMC40LDAtMC43LTAuMy0wLjctMC43YzAtMC4yLDAuMS0wLjMsMC4yLTAuNGw0LjQtNC40YzAuMy0wLjMsMC43LTAuMywwLjksMEwyMiw5LjgKCWMwLjMsMC4zLDAuNCwwLjYsMC4zLDAuOVMyMiwxMSwyMS44LDExeiIvPgo8L3N2Zz4K',
                    blob,
                    mataProjectId ? mataProjectId : null,
                    resolve,
                    reject
                );
            });
            if (rsp) {
                dispatch(setMataProjectId(rsp))
                // message.success('保存成功');
                message.success(intl.formatMessage({
                  id: "gui.meun.saved",
                  defaultMessage: "Successfully saved"
                }))
                dispatch(setLoadingModal(false))
                setSaveWorkModal(false)
                dispatch(setWriteState(false))
                if (saveWorkState !== 'py') {
                  window.location.href = window.location.origin
                } else {
                  actions.createFile(callBack => {
                    if (callBack) {
                      localStorage.setItem('projectTitle', callBack)
                      location.reload()
                      localStorage.removeItem('projectId')
                      dispatch(setProjectTitle(callBack))
                      dispatch(setProjectTitleold(callBack))
                      dispatch(setMataProjectId(''))
                    }
                  })
                }
                localStorage.removeItem('projectTitle')
            } else {
                // message.error('保存有误，请检查');
                message.success(intl.formatMessage({
                  id: "gui.meun.savedFailed",
                  defaultMessage: "Saving error, please check"
                }))
                dispatch(setLoadingModal(false))
            }
        } else {
            dispatch(setLoginModal(true))
        }
  }
  return (
    <div
      ref={fileRef}
      className={works ? 'menuBarItemSelect' : 'menuBarItem'}
      onMouseUp={onClickFile}
    >
      <div
        style={{ display: 'flex' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeaveOuter}
      >
        <img
          className="menuIcon"
          src={works ? fileIconSelected : fileIcon}
          alt="file"
        />
        <span
          style={{
            verticalAlign: 'middle',
            ...(works ? { color: '#3073ff' } : {})
          }}
        >
          {intl.formatMessage({
            id: "meun-item-file",
            defaultMessage: "File"
          })}
          {/* 文件 */}
        </span>
      </div>

      {works &&
        <div
            className="languageMenuContainer"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
          <div
              className="languageMenuItem"
              onClick={() => handleOpenAiProject()}
              // onClick={actions.createFile}
          >
              <div className="line"></div>
              {/* 新建图形化程序 */}
              {intl.formatMessage({
                id: "meun-item-file-newFile",
                defaultMessage: "New Block Coding"
              })}
          </div>
          <div
              className="languageMenuItem"
              onClick={() => handleOpenNewWorks()}
              // onClick={actions.createFile}
          >
              <div className="line"></div>
              {/* 新建Python程序 */}
              {intl.formatMessage({
                id: "meun-item-file-newPy",
                defaultMessage: "New Python Coding"
              })}
          </div>
          <div
              className="languageMenuItem"
          >
              <div className="line"></div>
              {/* 打开一份 */}
              <OpenButton mode="text" />
          </div>
          <div
              className="languageMenuItem"
              onClick={() => actions.save(menuButtonRef)}
          >
              <div className="line"></div>
              {intl.formatMessage({
                id: "meun-item-file-save",
                defaultMessage: "Save to Local"
              })}
              {/* 保存到本地 */}
          </div>
        </div>
      }

      {saveWorkModal &&
        <SaveWorkModal
          onCloseModal={handleCloseModal}
          onGetOkClick={handleOpenLink}
          onCancelModal={handleCancelModal}
        />
      }
    </div>
  );
};
export default WrapFileMenuItem;
